// extracted by mini-css-extract-plugin
export default {"onboardingModal":"OnboardingModal_onboardingModal__aaiDj","content":"OnboardingModal_content__YQ6Fe","counter":"OnboardingModal_counter__RyhwW"};